export const getModalInputStyles = isModal => {
	return isModal ? 12 : 6;
};

export const getModalSelectStyles = isModal => {
	return { sm: isModal ? 12 : 6 };
};
